<div class="container">
  <app-wheel-item *ngFor="let item of data" [data]="item" />
</div>
